var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4375 98.875C80.8406 98.875 99.8125 79.9031 99.8125 56.5C99.8125 33.0969 80.8406 14.125 57.4375 14.125C34.0344 14.125 15.0625 33.0969 15.0625 56.5C15.0625 79.9031 34.0344 98.875 57.4375 98.875Z",
    stroke: "#001489",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4375 35.3125V60.0312",
    stroke: "#001489",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 78C59.433 78 61 76.433 61 74.5C61 72.567 59.433 71 57.5 71C55.567 71 54 72.567 54 74.5C54 76.433 55.567 78 57.5 78Z",
    fill: "#001489"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning-circle.fb88ec6c4796166d99ba7d2084bde8e7.svg";